export default __webpack_public_path__ + "static/media/ico-setting-ex.bd04da6d.svg";